<div class="flex-content">
  <div class="content col-sm container-fluid">

    <div class="front-image-max">
      <img src="./../../../../assets/Contents/imgs/about_us_intro.png">
      <h2 class="front-title">About Visual Media Lab</h2>
    </div>

    <div class="row desc-box no-gutters">

      <div class="about-box">
      <!-- <p class="about-subtitle">The Visual Media Lab (VML) in the Graduate School of Culture Technology (GSCT) at KAIST is where technology and creativity meet.
        VML focuses on developing fundamental computer graphics technology and software applications specifically for the creation of movie visual effects and immersive environments to the viewers.
        The main research area includes character animation, immersive content generation and interactive environment.
        Since its foundation in 2006, VML has emphasized both R&D and contents production as a core part of lab activity.
        About 20 Ph.D. and master program researchers along with more than 10 digital artists have published numerous papers at premium graphics conferences
        and showcased animations at international computer animation festivals. The close relationship with industry has allowed
        VML to contribute its technology to recently released movies and new media platform. -->

      <!-- </p> -->
        <p class="about-subtitle">The Visual Media Lab (VML) in the Graduate School of Culture Technology (GSCT) at KAIST is where technology and creativity meet.
          Since its foundataion in 2006, VML has committed to advancing computer graphics technologies.
          Recently, it has focused on developing innovative solutions for character and facial animation, as well as image and video generation and editing.
          <br>
          <br>
          VML is renowned for its collaborative and open academic environment, encouraging students from various disciplines to engage, question, and innovate together.
          About 20 Ph.D. and Master program researchers have published numerous papers at premier graphics and vision conferences.
          The close relationship with the industry has allowed VML to contribute its technology to movies and new media platform.

        </p>
      </div>

      <h2 class="about-title">Contact us</h2>

      <div class="about">
        <div class="about-box">
          <h5 class="about-subtitle orange">Address</h5>
          <p class="about-text">Visual Media Lab, KAIST <br> 373-1 Guseong-dong, Yuseong-gu Daejeon, 305-701, Republic of Korea </p>

          <h5 class="about-subtitle orange">Telephone</h5>
          <p class="about-text">+82-42-350-5918</p>
          <h5 class="about-subtitle orange">Email</h5>
          <p class="about-text">visualmedia@kaist.ac.kr</p>
        </div>
        <!--<div class="about-img"><img src="../../../../assets/imgs/about_us_map.png" class="map"></div>-->
        <!--<sebm-google-map  [latitude]="lat" [longitude]="lng">
          <sebm-google-map-marker [latitude]="lat" [longitude]="lng"></sebm-google-map-marker>
        </sebm-google-map>-->

        <!--Commented out map temporaly-->
        <!--<div id="map" class="about-img"></div>-->
      </div>


    </div>
  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/about-info/about-info.component.html